/**
 * @generated SignedSource<<48fa0b1fdc6813ad6f20e84f92d467f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveFrom"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveTo"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "identifierTypeId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "identifierUseCodeId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v6 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "effectiveFrom",
        "variableName": "effectiveFrom"
      },
      {
        "kind": "Variable",
        "name": "effectiveTo",
        "variableName": "effectiveTo"
      },
      {
        "kind": "Variable",
        "name": "identifierTypeId",
        "variableName": "identifierTypeId"
      },
      {
        "kind": "Variable",
        "name": "identifierUseCodeId",
        "variableName": "identifierUseCodeId"
      },
      {
        "kind": "Variable",
        "name": "practitionerIdentifierId",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "value",
        "variableName": "value"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "display",
    "storageKey": null
  },
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditPractitionerIdentifierModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PractitionerMutationGroup",
        "kind": "LinkedField",
        "name": "practitioner",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "PractitionerIdentifierModifyPayload",
            "kind": "LinkedField",
            "name": "modifyIdentifier",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PractitionerIdentifier",
                "kind": "LinkedField",
                "name": "practitionerIdentifier",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Practitioner",
                    "kind": "LinkedField",
                    "name": "practitioner",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PractitionerIdentifier",
                        "kind": "LinkedField",
                        "name": "identifiers",
                        "plural": true,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "PractitionerIdentifiers_Identifiers"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditPractitionerIdentifierModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PractitionerMutationGroup",
        "kind": "LinkedField",
        "name": "practitioner",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "PractitionerIdentifierModifyPayload",
            "kind": "LinkedField",
            "name": "modifyIdentifier",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PractitionerIdentifier",
                "kind": "LinkedField",
                "name": "practitionerIdentifier",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Practitioner",
                    "kind": "LinkedField",
                    "name": "practitioner",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PractitionerIdentifier",
                        "kind": "LinkedField",
                        "name": "identifiers",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IdentifierType",
                            "kind": "LinkedField",
                            "name": "identifierType",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IdentifierUseCode",
                            "kind": "LinkedField",
                            "name": "identifierUseCode",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveFrom",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveTo",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "291b09531b318734919a4a71c260d510",
    "id": null,
    "metadata": {},
    "name": "EditPractitionerIdentifierModalMutation",
    "operationKind": "mutation",
    "text": "mutation EditPractitionerIdentifierModalMutation(\n  $id: ID!\n  $identifierTypeId: ID!\n  $identifierUseCodeId: ID!\n  $value: String!\n  $effectiveFrom: DateOnly!\n  $effectiveTo: DateOnly!\n) {\n  practitioner {\n    modifyIdentifier(input: {practitionerIdentifierId: $id, identifierTypeId: $identifierTypeId, identifierUseCodeId: $identifierUseCodeId, value: $value, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {\n      practitionerIdentifier {\n        id\n        practitioner {\n          id\n          identifiers {\n            ...PractitionerIdentifiers_Identifiers\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment PractitionerIdentifiers_Identifiers on PractitionerIdentifier {\n  id\n  identifierType {\n    display\n    id\n  }\n  identifierUseCode {\n    display\n    id\n  }\n  value\n  effectiveFrom\n  effectiveTo\n}\n"
  }
};
})();

node.hash = "d77d470e3b676eb25b0bcbf64b5b2543";

export default node;
